import React, {lazy, Suspense} from 'react'

const AccessPortalPageLazy = lazy(() =>
    import('./AccessPortalPage')
)

const AccessPortalPage = props => (
    <Suspense fallback={null}>
        <AccessPortalPageLazy {...props} />
    </Suspense>
)

export default AccessPortalPage
